import React, { useState, useEffect } from 'react';
import '../styles/style.css';
import '../styles/mediaqueries.css';
import profilePicture from '../assets/Picture1.jpg';
import SocialIcon from './SocialIcon';
import { mdiLinkedin, mdiGithub } from '@mdi/js';
import ResumeRequestModal from './ResumeRequestModal';

function Profile() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setVisible(true), 100);
        return () => clearTimeout(t);
    }, []);

    return (
        <>
            <section id="profile">
                {/* ── PHOTO ── */}
                <div
                    className="section__pic-container"
                    style={{
                        opacity: visible ? 1 : 0,
                        transform: visible ? 'translateY(0)' : 'translateY(24px)',
                        transition: 'opacity 0.8s ease 0.2s, transform 0.8s ease 0.2s',
                    }}
                >
                    <img
                        src={profilePicture}
                        alt="Samwel Waithaka"
                        draggable={false}
                        onContextMenu={(e) => e.preventDefault()}
                        style={{ userSelect: 'none', pointerEvents: 'auto' }}
                    />
                </div>

                {/* ── TEXT ── */}
                <div
                    className="section__text"
                    style={{
                        opacity: visible ? 1 : 0,
                        transform: visible ? 'translateY(0)' : 'translateY(24px)',
                        transition: 'opacity 0.8s ease, transform 0.8s ease',
                    }}
                >
                    {/* Name */}
                    <p className="section__text__p1">Hello, I'm</p>
                    <h1 className="title">
                        Samwel<br/>
                        <span className="spark-word">Waithaka</span>
                    </h1>

                    {/* Role */}
                    <p className="section__text__p2">Software_Engineer();</p>

                    {/* Identity tags */}
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '0.5rem',
                        marginBottom: '1.75rem',
                        justifyContent: 'center',
                    }}>
                        {['BACKEND DEVELOPER', 'IOT ENGINEER'].map(tag => (
                            <span key={tag} style={{
                                fontFamily: "'JetBrains Mono', monospace",
                                fontSize: '0.62rem',
                                fontWeight: 700,
                                letterSpacing: '0.1em',
                                padding: '0.2rem 0.65rem',
                                borderRadius: '100px',
                                border: '1px solid rgba(124, 58, 237, 0.3)',
                                color: 'var(--violet)',
                                background: 'rgba(124, 58, 237, 0.08)',
                            }}>
                                {tag}
                            </span>
                        ))}
                    </div>

                    {/* CTA Buttons */}
                    <div className="btn-container">
                        <button
                            className="btn btn-color-2"
                            onClick={() => setIsModalOpen(true)}
                        >
                            Request CV ↗
                        </button>
                        <button
                            className="btn btn-color-1"
                            onClick={() => window.location.href = '#contact'}
                        >
                            Contact Info
                        </button>
                    </div>

                    {/* Social Icons */}
                    <div id="socials-container">
                        <SocialIcon
                            path={mdiLinkedin}
                            href="https://linkedin.com/in/idrisfallout/"
                            title="LinkedIn"
                        />
                        <SocialIcon
                            path={mdiGithub}
                            href="https://github.com/IdrisFallout"
                            title="GitHub"
                        />
                    </div>
                </div>
            </section>

            <ResumeRequestModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    );
}

export default Profile;